"use strict";

import {find,addClass, removeClass, on, closest} from '@elements/dom-utils';

const selectors = {
    input: '.js-search__input',
    resetInput: '.js-search__reset-input',
};

export function init () {
    let input = find(selectors.input);
    let resetBtn = find(selectors.resetInput);

    on('click', function(evt) {
         evt.preventDefault();
         input.value = '';
     }, resetBtn);
}



